<script setup>
import { computed, watch, ref } from 'vue';

import { useRoute } from 'vue-router';
import SearchResults from '@/components/Search/SearchResults.vue';
const active = ref(false);

const closeContacts = () => {
  active.value = false;
  document.body.style.overflow = '';
};

const toggleContacts = () => {
  active.value = !active.value;
  if (active.value) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
};

const route = useRoute();
watch(
  () => route.fullPath,
  () => {
    document.body.style.overflow = '';
    active.value = false;
  },
);
</script>

<template>
  <div :class="['header-search', active ? 'header-search--active' : '']">
    <button
      class="header-search__button js-button-search"
      type="button"
      :aria-label="$t('search.search_button')"
      @click.stop="toggleContacts"
    >
      <CIcon
        class="header-search__icon"
        name="search-black"
        width="16"
        height="16"
      />
    </button>
    <transition name="morph">
      <div v-if="active" class="header-search__modal">
        <SearchResults :view="'header'" />
      </div>
    </transition>
    <div
      v-if="active"
      class="header-search__overlay"
      @click="closeContacts"
    ></div>
  </div>
</template>

<style scoped lang="scss">
.header-search {
  &__icon {
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(height, 16);
      @include responsive-spacing(width, 16);
    }
  }
  &__button {
    align-items: center;
    display: flex;
    justify-content: center;
    height: 32px;
    width: 32px;
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(height, 32);
      @include responsive-spacing(width, 32);
    }
  }
  &__modal {
    left: 16px;
    position: fixed;
    right: 16px;
    top: 16px;
    z-index: 2;
    @include media-breakpoint-up(sm) {
      left: 20px;
      right: 20px;
      top: 24px;
    }
    @include media-breakpoint-up(md) {
      max-width: 784px;
      margin: 0 auto;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(top, 24);
      @include responsive-spacing(right, 20);
      @include responsive-spacing(left, 20);
      @include responsive-spacing(max-width, 784);
    }
  }
  &__overlay {
    background-color: rgba($black, 0.7);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1;
  }
}
.morph-enter-active,
.morph-leave-active {
  transition:
    transform 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.4s ease,
    border-radius 0.5s ease;
}

.morph-enter-from,
.morph-leave-to {
  opacity: 0;
  transform: scale(0);
  border-radius: 50%;
}

.morph-enter-to,
.morph-leave-from {
  opacity: 1;
  transform: scale(1);
}
</style>
